<template>
    <div class="model-files">

        <div class="d-flex align-items-center">

            <!-- Upload Files-->
            <button class="btn btn-sm btn-success" @click="openModal(`upload-files-modal-${_uid}`)" v-if="uploadFiles" >
                <i class="fa fa-plus-circle"></i> Upload Files
            </button>

            <modal :id="`upload-files-modal-${_uid}`" :show-footer="false" v-if="uploadFiles">
                <template slot="title">Upload File</template>
                <template slot="body">
                    <dropzone :url="url" @success="success"></dropzone>
                </template>
            </modal>

            <div class="ml-auto d-flex">
                <!-- Delete File-->
                <div v-if="enableDelete">
                    <button class="btn btn-danger btn-sm mr-1" v-if="selectedItem" @click="openModal(`delete-file-modal-${_uid}`)">
                        <i class="far fa-trash-alt"></i> Delete
                    </button>
                    <delete-file-modal :file="selectedItem" v-if="selectedItem" @deleted="remove" :id="_uid"></delete-file-modal>
                </div>

                <!-- Update File-->
                <div v-if="enableUpdate">
                    <button class="btn btn-primary btn-sm mr-1" v-if="selectedItem" @click="openModal(`update-file-modal`)">
                        <i class="far fa-edit"></i> Update
                    </button>
                    <update-file-modal :file="selectedItem" v-if="selectedItem"></update-file-modal>
                </div>

                <!-- Preview File-->
                <div v-if="enablePreview">
                    <button  class="btn btn-info btn-sm mr-1" v-if="selectedItem" @click="openModal(`preview-file-modal-${_uid}`)">
                        <i class="fas fa-eye"></i> Preview
                    </button>
                    <preview-file-modal :file="selectedItem" v-if="selectedItem" :id="_uid" @previous="previousFile" @next="nextFile"></preview-file-modal>
                </div>
            </div>

        </div>

        <!-- List of Files-->
        <div class="table-tabs-container">
            <table class="table table-hover table-sm">
                <thead>
                    <tr>
                        <th width="50"></th>
                        <th>Name</th>
                        <th>Size</th>
                        <th v-if="displayOwner">Owner</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="file in files" :key="file.id" @click="selectItem(file)" class="clickleable">
                        <td class="text-center">
                            <input type="radio" name="option" :value="file" v-model="selectedItem">
                        </td>
                        <td v-text="strlimit(file.name, 50)"></td>
                        <td>
                            <span v-if="file.size" v-text="prettyBytes(file.size)"></span>
                        </td>
                        <td v-if="displayOwner" v-text="file.owner.name"></td>
                        <td v-text="shortDate(file.created_at)"></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <paginator :paginator="paginator" @change="changePage"></paginator>
    </div>
</template>
<script>
    let OptionItems = require('@/mixins/OptionItems');

    export default {

        mixins: [OptionItems],

        props: {
            data:{
                type: Object,
                required: true,
            },
            url: {
                type: String,
                required: true,
            },
            uploadFiles:{
                type: Boolean,
                required: false,
                default: true,
            },
            enableUpdate:{
                type: Boolean,
                required: false,
                default: true,
            },
            enableDelete:{
                type: Boolean,
                required: false,
                default: true,
            },
            enablePreview:{
                type: Boolean,
                required: false,
                default: true,
            },
            displayOwner:{
                type: Boolean,
                required: false,
                default: true,
            },

        },

        data() {
            return {
                paginator: this.data,
                files: this.data.data,
            }
        },

        methods: {

            success(file) {
                this.files.unshift(file);
                this.closeModal(`upload-files-modal-${this._uid}`)
            },

            remove(file) {
                var index = this.files.indexOf(file);
                this.files.splice(index, 1);
                this.$emit('removed', file);
                this.selectedItem = null;
            },

            changePage(event) {
                this.redirectTo(`${window.location.pathname}?page=${event}&tab=files`);
            },

            previousFile(){
                var index = this.files.indexOf(this.selectedItem);
                if(index == 0) index = this.files.length;
                this.selectedItem = this.files[index - 1];
            },

            nextFile(){
                var index = this.files.indexOf(this.selectedItem);
                if(index == this.files.length) index = 0;
                this.selectedItem = this.files[index + 1];
            }
        }
    }
</script>